$(document).bind('_js_ready', function() {
	$("#popin_acces_rapides.reveal").on("open.zf.reveal",function(){
		$(this).removeClass("slide-out-right mui-leave mui-leave-active");
		$('#btn_acces_rapides').foundation("_calc", true);
	});
	$("#popin_acces_rapides.reveal").on("closed.zf.reveal",function(){
		$(this).addClass("slide-out-right mui-leave mui-leave-active");
	});
	$("#popin_acces_rapides").on('scroll',function(){
		animate();
	});
});